export const sessionSetString = (name, value) => {
	sessionStorage.setItem(name, value);
};

export const sessionSetObject = (name, value) => {
	try {
		sessionStorage.setItem(name, JSON.stringify(value));
		return true;
	} catch (err) {
		return false;
	}
};

export const sessionGetString = (name) => {
	return sessionStorage.getItem(name);
};

export const sessionGetObject = (name) => {
	try {
		return JSON.parse(sessionStorage.getItem(name));
	} catch (err) {
		return null;
	}
};

export const sessionHasStringInArray = (arrayName, name) => {
	try {
		const arr = JSON.parse(sessionStorage.getItem(arrayName));
		return arr.indexOf(name) !== -1;
	} catch (err) {
		return false;
	}
};

export const sessionDeleteItem = (name) => {
	sessionStorage.removeItem(name);
};

export const sessionClearAll = (name) => {
	sessionStorage.clear();
};
